import { FirmOverviewTable } from './firmOverviewTable';

export default FirmOverviewTable;